<div class="chat-input__bar d-flex flex-column px-3 py-2">
  <!-- Attachment previews -->
  @if (files().length > 0) {
  <div class="d-flex flex-wrap gap-2 px-1 pb-2 align-items-start">
    @for (f of files(); track f.localId) {

      @if (isImageAttachment(f) && f.status !== 'error') {
      <!-- Image thumbnail -->
      <div class="position-relative chat-input__thumb">
        <div class="chat-input__thumb-img rounded overflow-hidden">
          @if (f.status === 'uploading') {
          <div class="w-100 h-100 d-flex align-items-center justify-content-center chat-input__thumb-placeholder">
            <mat-progress-spinner diameter="24" mode="indeterminate" />
          </div>
          } @else {
          <img [src]="getPreviewUrl(f)" [alt]="f.file.name" class="w-100 h-100 object-fit-cover" />
          }
        </div>
        <button class="chat-input__thumb-remove position-absolute rounded-circle d-flex align-items-center justify-content-center"
                (click)="removeFile(f.localId)"
                [attr.aria-label]="'Remove ' + f.file.name">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      } @else {
      <!-- Non-image file chip -->
      <mat-chip (removed)="removeFile(f.localId)">
        <span class="d-flex align-items-center gap-1">
          @if (f.status === 'uploading') {
          <mat-progress-spinner diameter="12" mode="indeterminate" />
          }
          @if (f.status === 'error') {
          <mat-icon class="mat-text-error chat-input__chip-icon">error</mat-icon>
          }
          <span class="mat-font-label-sm" [class.mat-text-error]="f.status === 'error'">
            {{ f.status === 'error' ? (f.error || 'Upload failed') : f.file.name }}
          </span>
        </span>
        <button matChipRemove [attr.aria-label]="'Remove ' + f.file.name">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>
      }

    }
  </div>
  }

  <!-- Input row -->
  <div class="d-flex align-items-center gap-2">
    <mat-form-field appearance="outline" class="flex-fill" subscriptSizing="dynamic">
      <textarea
        matInput
        cdkTextareaAutosize
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="5"
        [placeholder]="placeholder()"
        [disabled]="isDisabled()"
        [value]="chatState.inputValue()"
        (input)="chatState.changeInput($any($event.target).value)"
        (keydown.enter)="onEnter($event)"></textarea>
    </mat-form-field>

    <input type="file" #fileInput hidden [accept]="acceptedTypes" multiple (change)="onFilesSelected($event)" />
    <button matIconButton [disabled]="!canAttach()" (click)="onAttachClick()" aria-label="Attach file">
      <mat-icon>attach_file</mat-icon>
    </button>


    <button
      matMiniFab
      color="primary"
      [disabled]="(!chatState.inputValue().trim() && !files().length) || isDisabled()"
      (click)="submit()"
      aria-label="Send message">
      <mat-icon [class.spin-icon]="isLoading() && !isBlocked()">{{ isBlocked() ? "pending" : isLoading() ? "sync" : "send" }}</mat-icon>
    </button>
  </div>

<!--  &lt;!&ndash; Safety disclaimer &ndash;&gt;-->
<!--  <p class="mat-font-label-sm text-center mt-2 mb-0 mat-text-on-surface-variant">-->
<!--    AI can make mistakes. Verify critical data with Vexcel sources.-->
<!--  </p>-->
</div>
